var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"users f-c-b f-d-c w-100 h-100 p-4 pb-22 o-f-a"},[_c('router-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gapMaterial f-c-c w-100"},[_c('div',{staticClass:"text blueText f-c-c"},[_vm._v(" کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می باشد. ")])])
}]

export { render, staticRenderFns }